import {RootState} from '../../store';
import {Product} from './types';

export const selectionSelector = (state: RootState): Record<string, Product> =>
    state['products'].selection as Record<string, Product>;
